export default __webpack_public_path__ + "static/media/tampaBayBuccaneers@2x.1d98bdc6.jpg";